export class BuyerModel {
  buyerID: number;
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  contactNumber: string;

  constructor(data?: any) {
    this.buyerID = data?.buyerID ?? 0;
    this.username = data?.username ?? "";
    this.password = data?.password ?? "";
    this.firstname = data?.firstname ?? "";
    this.lastname = data?.lastname ?? "";
    this.companyName = data?.companyName ?? "";
    this.addressLine1 = data?.addressLine1 ?? "";
    this.addressLine2 = data?.addressLine2 ?? "";
    this.city = data?.city ?? "";
    this.state = data?.state ?? "";
    this.postcode = data?.postcode ?? "";
    this.country = data?.country ?? "";
    this.contactNumber = data?.contactNumber ?? "";
  }
}